import { Box, BoxProps, Button, ButtonProps, useTheme } from "@mui/material";
import { withBackgroundImage } from "../../hocs/withBackgroundImage";

const BadgeUI = (props: BoxProps) => {
  const { sx, ...rest } = props;
  return (
    <Box
      sx={{
        minHeight: "0px",
        borderRadius: "72px",
        padding: "0px 8px",
        backgroundColor: "#FFFFFF08", // TODO: use theme
        border: "0.3px solid #FFFFFF", // TODO: use theme
        ...sx,
      }}
      {...rest}>
      {props.children}
    </Box>
  );
};

const ItemUI = (props: BoxProps) => {
  const { sx, ...rest } = props;
  return (
    <Box
      sx={{
        borderRadius: "16px",
        padding: "8px",
        backgroundColor: "#FFFFFF08", // TODO: use theme
        border: "1px solid #FFFFFF0D", // TODO: use theme
        ...sx,
      }}
      {...rest}>
      {props.children}
    </Box>
  );
};

const SectionUI = (props: BoxProps) => {
  const { sx, ...rest } = props;
  const theme = useTheme();

  return (
    <Box
      sx={{
        borderRadius: "12px",
        padding: "12px",
        backgroundColor: `${theme.palette.surface.light}08`,
        ...sx,
      }}
      {...rest}>
      {props.children}
    </Box>
  );
};

const CardUI = {
  Badge: BadgeUI,
  Item: ItemUI,
  Section: SectionUI,
  ImageSection: withBackgroundImage(SectionUI),
};

export { CardUI };
